import { render, staticRenderFns } from "./PasswordExpired.vue?vue&type=template&id=41234013&scoped=true&"
import script from "./PasswordExpired.vue?vue&type=script&lang=js&"
export * from "./PasswordExpired.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpired.vue?vue&type=style&index=0&id=41234013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41234013",
  null
  
)

component.options.__file = "PasswordExpired.vue"
export default component.exports